// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { initFlowbite } from 'flowbite'

// Initialize Flowbite on page load
initFlowbite()

// Re-initialize Flowbite after Turbo navigation
document.addEventListener('turbo:load', () => {
  initFlowbite()
})

document.addEventListener('turbo:render', () => {
  initFlowbite()
})
